import { render, staticRenderFns } from "./FuzzyLinkHandler.vue?vue&type=template&id=39bf685d&scoped=true&"
import script from "./FuzzyLinkHandler.vue?vue&type=script&lang=js&"
export * from "./FuzzyLinkHandler.vue?vue&type=script&lang=js&"
import style0 from "./FuzzyLinkHandler.vue?vue&type=style&index=0&id=39bf685d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf685d",
  null
  
)

export default component.exports